import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { environment } from '../environments/environment';
/***** 【 Components 】 *****/
import { AppComponent } from './app.component';
/***** 【Modules】 *****/
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
/***** 【Custom Installed】 *****/
import { ToastrModule } from 'ngx-toastr';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxLoadingModule } from 'ngx-loading';
import { JwtModule } from '@auth0/angular-jwt';
/***** 【i18n】 *****/
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './classes/custom-mat-paginator-intl';
// 建立TranslateHttpLoader作為語系檔的讀取器
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
/***** 【 Interceptors 】 *****/
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { RequestTimeLogInterceptor } from './interceptors/request-time-log.interceptor';
/***** 【Socket】 *****/
// import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
// const config: SocketIoConfig = { url: 'https://gowint.com:3002', options: {} };
// const config: SocketIoConfig = { url: 'http://localhost:3000', options: {} };
/***** 【 App初始化 initializeApp 】 *****/
import { StartupService } from './services/startup.service';
export function startupServiceFactory(startupService: StartupService): Function { return () => startupService.initializeApp(); }

export function jwtTokenGetter() { return localStorage.getItem('access_token'); }


import { APP_BASE_HREF } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), 
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }), // ToastrModule added
    // SocketIoModule.forRoot(config),
    NgxLoadingModule.forRoot({}),
    JwtModule.forRoot({
      config: {
        tokenGetter: jwtTokenGetter
      }
    }),
  ],
  providers: [
    // {provide: APP_BASE_HREF, useValue: '/adminPanel'},
    {
      provide: APP_INITIALIZER,
      useFactory: startupServiceFactory,
      deps: [StartupService, Injector],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestTimeLogInterceptor,
      multi: true
    },
    {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginatorIntl,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
  }
}
